import { jsx as _jsx } from "react/jsx-runtime";
/* Entrypoint for webpack build. */
// polyfill stable 'core-js' features - ES and web standards
import 'core-js/stable';
// Third party libraries used site wide.
import 'lazysizes';
import importWithRetry from './components/common/import_with_retry';
// Import main sass file to be compiled to CSS by webpack.
import './scss/main.scss';
// Import site wide JS modules that contain small utility functions.
import './site_wide_scripts/capture_email_lead_utils';
import './site_wide_scripts/nom_nav';
import './site_wide_scripts/nom_utils';
import './site_wide_scripts/sentry';
// Import admin_utils only on admin site
if (window.IS_ADMIN_DOMAIN) {
    importWithRetry(function () { return import(/* webpackChunkName: "admin_utils" */ './site_wide_scripts/admin_utils'); });
}
var _PATH_NAME = window.location.pathname;
if (_PATH_NAME.startsWith('/site/products/') || _PATH_NAME.startsWith('/site/how-it-works')) {
    importWithRetry(function () { return import(/* webpackChunkName: "carousel" */ './site_wide_scripts/carousel'); });
}
if (_PATH_NAME.startsWith('/health/report/') || _PATH_NAME.startsWith('/health/microbiome/')) {
    importWithRetry(function () { return import(/* webpackChunkName: "reports" */ './site_wide_scripts/reports'); });
}
var _LOAD_REACT = _PATH_NAME.startsWith('/profile') ||
    _PATH_NAME.startsWith('/site/nutrient-calculator') ||
    _PATH_NAME.startsWith('/health/survey/') ||
    _PATH_NAME.startsWith('/a/') ||
    _PATH_NAME.startsWith('/account/') ||
    _PATH_NAME.startsWith('/marketing/') ||
    window.IS_ADMIN_DOMAIN;
if (_LOAD_REACT) {
    Promise.all([
        importWithRetry(function () { return import(/* webpackChunkName: "react" */ 'react'); }),
        importWithRetry(function () { return import(/* webpackChunkName: "react-dom" */ 'react-dom/client'); }),
        importWithRetry(function () { return import(/* webpackChunkName: "error_boundary" */ './components/common/error_boundary'); }),
    ]).then(function (_a) {
        var React = _a[0], ReactDOMClient = _a[1], errorBoundary = _a[2].default;
        var renderComponent = function (elementId, App) {
            var rootElement = document.getElementById(elementId);
            if (rootElement) {
                ReactDOMClient.createRoot(rootElement).render(_jsx(App, {}));
            }
        };
        // NEW Account app
        if (document.querySelector('#react-container-account_app_v2')) {
            var AccountApp = errorBoundary(React.lazy(function () { return import('./redesign/app/account/page'); }));
            renderComponent('react-container-account_app_v2', AccountApp);
        }
        // NEW Admin Account app
        if (document.querySelector('#react-container-admin-account_app_v2')) {
            var AdminAccountApp = errorBoundary(React.lazy(function () {
                return import('./redesign/app/account/page').then(function (module) { return ({
                    default: module.AdminAccountApp,
                }); });
            }));
            renderComponent('react-container-admin-account_app_v2', AdminAccountApp);
        }
        // NEW Marketing App
        if (document.querySelector('#react-container-marketing')) {
            var MarketingApp = errorBoundary(React.lazy(function () { return import('./marketing/app'); }));
            renderComponent('react-container-marketing', MarketingApp);
        }
        // Sign up app
        if (_PATH_NAME.startsWith('/profile')) {
            var SignUpApp = errorBoundary(React.lazy(function () { return import('./components/signup'); }));
            renderComponent('react-container-signup', SignUpApp);
        }
        // Account app
        if (document.querySelector('#react-container-account')) {
            var AccountApp = errorBoundary(React.lazy(function () { return import('./components/account/'); }));
            renderComponent('react-container-account', AccountApp);
        }
        // Admin stats app
        if (document.querySelector('#react-container-admin-stats')) {
            var AdminStatsApp = errorBoundary(React.lazy(function () { return import('./components/admin/stats_feed/'); }));
            renderComponent('react-container-admin-stats', AdminStatsApp);
        }
        // Admin address verification app
        if (document.querySelector('#react-container-verify-address')) {
            var VerifyAddressApp = errorBoundary(React.lazy(function () { return import('./components/admin/verify_address/'); }));
            renderComponent('react-container-verify-address', VerifyAddressApp);
        }
        // Admin cook preview request app
        if (document.querySelector('#react-container-create-cook-form')) {
            var CreateCookApp = errorBoundary(React.lazy(function () { return import('./components/admin/create_cook_form.jsx'); }));
            renderComponent('react-container-create-cook-form', CreateCookApp);
        }
        // Admin customer search app
        if (document.querySelector('#react-container-customer-search')) {
            var CustomerSearchApp = errorBoundary(React.lazy(function () { return import('./components/admin/customer_search.jsx'); }));
            renderComponent('react-container-customer-search', CustomerSearchApp);
        }
        // Cost Model App
        if (document.querySelector('#react-container-cost-model')) {
            var CostModelApp = errorBoundary(React.lazy(function () { return import('./components/admin/cost_model'); }));
            renderComponent('react-container-cost-model', CostModelApp);
        }
        // Pet Photos App
        if (document.querySelector('#react-container-pet-photos')) {
            var PetPhotosApp = errorBoundary(React.lazy(function () { return import('./components/admin/pet_photos'); }));
            renderComponent('react-container-pet-photos', PetPhotosApp);
        }
        // Admin pack print app
        if (document.querySelector('#react-container-pack-print')) {
            var PackPrintApp = errorBoundary(React.lazy(function () { return import('./components/admin/pack_print'); }));
            renderComponent('react-container-pack-print', PackPrintApp);
        }
        // Admin print inventory labels app
        if (document.querySelector('#react-container-inventory-labels')) {
            var InventoryLabelsApp = errorBoundary(React.lazy(function () { return import('./components/admin/inventory_labels'); }));
            renderComponent('react-container-inventory-labels', InventoryLabelsApp);
        }
        // Admin order update app
        if (document.querySelector('#react-container-order-update')) {
            var OrderUpdateApp = errorBoundary(React.lazy(function () { return import('./components/admin/order/order_update'); }));
            renderComponent('react-container-order-update', OrderUpdateApp);
        }
        // Admin order fulfillment scan app
        if (document.querySelector('#react-container-fulfillment-scan')) {
            var OrderFulfillmentScanApp = errorBoundary(React.lazy(function () { return import('./components/admin/order_fulfillment_scan'); }));
            renderComponent('react-container-fulfillment-scan', OrderFulfillmentScanApp);
        }
        // Admin order pack scan app
        if (document.querySelector('#react-container-order-pack-scan')) {
            var OrderPackScanApp = errorBoundary(React.lazy(function () { return import('./components/admin/order_pack_scan'); }));
            renderComponent('react-container-order-pack-scan', OrderPackScanApp);
        }
        // Admin Buy Shipping Label form
        if (document.querySelector('#react-container-buy-shipping-label')) {
            var BuyShippingLabelForm = errorBoundary(React.lazy(function () { return import('./components/admin/buy_shipping_labels'); }));
            renderComponent('react-container-buy-shipping-label', BuyShippingLabelForm);
        }
        // Nutrient calculator app
        if (document.querySelector('#react-container-nutrient-calculator')) {
            var NutrientCalculatorApp = errorBoundary(React.lazy(function () { return import('./components/nutrient_calculator'); }));
            renderComponent('react-container-nutrient-calculator', NutrientCalculatorApp);
        }
        // Retail app
        if (document.querySelector('#react-container-retail')) {
            var RetailApp = errorBoundary(React.lazy(function () { return import('./components/admin/retail'); }));
            renderComponent('react-container-retail', RetailApp);
        }
    });
}
